<div
  class="fixed inset-0 z-[9999] flex justify-center items-center bg-white bg-opacity-80 transition-opacity duration-300 ease-in-out"
  [ngClass]="{
    'opacity-0 pointer-events-none': !spinnerService.status,
    'opacity-100': spinnerService.status
  }"
>
  <div class="flex flex-col justify-center items-center">
    <img src="assets/images/logo/logo-med-joven.svg" alt="Logo" class="w-10/12 lg:w-96" />

    <div role="status" class="flex justify-center mt-4">
      <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- Tus paths aquí -->
      </svg>
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
